import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/regulations/(sections)/Hero/assets/flag.png");
;
import(/* webpackMode: "eager", webpackExports: ["AppearInView"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/animations/AppearInView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HideOnQueryParam"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/HideOnQueryParam/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NBSP"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/I18nSubstitutions/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/Icons/IconCurvedArrow/IconCurvedArrow.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/layout/Section/Section.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/layout/VStack/VStack.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/layout/CenterHeading/CenterHeading.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/Logo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkRewardCenter","LinkSignup"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/PlatformLink/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/SectionsGroup/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/regulations/(sections)/RegulationsCardsSection/RegulationsCard/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["APKButtonShort"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/StoreButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormatAmount"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/formatters/format-price.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/assets/logo_cryptovalley.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterBottomBigLogo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactAndSupportButton"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterContactsAndSocialsSection/ContactAndSupportButton.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterContactsAndSocialsSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterLayout/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["FooterMobileAppsBlockQr"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterLeftActionGroup/FooterMobileApps/FooterMobileAppsBlockQr/index..tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterMobileAppIOSButton","FooterMobileAppAndroidButton"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterLeftActionGroup/FooterMobileApps/FooterMobileAppsButtons.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterLeftActionGroup/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterLegalSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterLinksBar/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterNav/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/layout/CardsGrid/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/discord.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/fb-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/instagram-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/linked_in.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/reddit-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/telegram.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/tiktok-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/twitter-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/yt-icon.svg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterTrustpilot/img/logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterTrustpilot/img/stars.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterTrustpilot/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/variants/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/BonusCard/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/Container/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderActionsWithoutPromotions","HeaderCommonActions"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Components/Actions/ActionsContainer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderGiftBanner"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Components/Actions/GiftBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderInner"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Components/HeaderInner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuCtaBlockMobileStoreButton"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Components/Mobmenu/CtaBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConvertersWidget"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Components/Widgets/Converters/ConvertersWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderPartners"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Versions/HeaderPartners/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/styles/background.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/styles/contexts.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/styles/button.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/styles/rtl.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/styles/typography.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Versions/WaitlistHeader/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Hero/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/styles/link.module.scss");
